// Date string is YYYY-MM-DD
export function formatDateString(date: string, monthLength: 'short' | 'long' = 'short', includeWeekday = true) {
  if (includeWeekday) {
    return (new Date(date))
      .toLocaleString(
        'en-US',
        { timeZone: 'UTC', day: '2-digit', month: monthLength, year: 'numeric', weekday: 'short' }
      );
  }

  return (new Date(date))
    .toLocaleString(
      'en-US',
      { timeZone: 'UTC', day: '2-digit', month: monthLength, year: 'numeric' }
    );
}

export function formatLongDate(dateString: string) {
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).replace(',', ' at');
}

export function formatShortDate(dateString: string) {
  if (!dateString) return;
  if ((/\d{4}-\d{1,2}-\d{1,2}/).test(dateString)) return formatDateFromIso8601(dateString);

  const date = new Date(dateString);

  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
}

function formatDateFromIso8601(dateString: string) {
  const datePart = dateString.split('T')[0];
  const parts = datePart.split('-');
  return `${parts[1]}/${parts[2]}/${parts[0]}`;
}
